import * as Yup from 'yup';

// 共通バリデーション
const fullWidthName = Yup.string()
  .matches(/^[^\x01-\x7E\xA1-\xDF]+$/, '全角で入力してください')
  .max(19, '全角19文字以内で入力してください');

const fullWidthKana = Yup.string()
  .matches(/^[ァ-ンｧ-ﾝﾞﾟ\-ー]+$/, '全角カナで入力してください')
  .max(19, '全角19文字以内で入力してください');

const email = Yup.string()
  .email('メールアドレスの形式が異なります')
  .matches(/^[\x20-\x7E]+$/, 'メールアドレスの形式が異なります')
  .max(100, 'メールアドレスは100文字以内で入力してください');

// 車情報のバリデーションスキーマ
export const carInfoValidationSchema = Yup.object().shape({
  year: Yup.string().matches(/^\d{4}$/, '半角数字4桁で入力してください'),
  mileage: Yup.string()
    .matches(/^\d*$/, '半角数字で入力してください')
    .max(6, '6桁以内で入力してください'),
});

// ユーザー情報のバリデーションスキーマ
export const userInfoValidationSchema = Yup.object().shape({
  lastName: fullWidthName,
  firstName: fullWidthName,
  lastNameKana: fullWidthKana,
  firstNameKana: fullWidthKana,
  phoneNumber: Yup.string()
    .matches(/^[0-9]+$/, '半角数字で入力してください')
    .min(10, '10桁以上で入力してください')
    .max(11, '11桁以内で入力してください'),
  email: email,
  emailConfirm: Yup.string().oneOf(
    [Yup.ref('email')],
    'メールアドレスが一致しません'
  ),
});

// ゲスト予約照会のバリデーションスキーマ
export const verifySchema = Yup.object().shape({
  reserveNumber: Yup.string()
    .matches(/^[0-9]+$/, '半角数字で入力してください')
    .max(14, '予約番号は14桁以内で入力してください'),
  email: email,
});
